import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { style } from "./styles";
import { Grid } from "@material-ui/core";
import Header from "../../partials/header";
import Form from "./form";
import Loading from "../loading";
export class ProductMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  async componentDidMount() {
    this.props.getProductCategory();
    this.props.getProduct();
  }
  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let state = this.state;
    state[name] = value;
    this.setState({
      state,
    });
  };
  handleAddForm = async (data) => {
    this.loading.startLoading();
    let inputFile = this.form.getInputFile();
    let files = inputFile.files;
    let src = inputFile.src;
    if (files !== null) {
      let checkUpload = await this.props.uploadDispatch.saveStorage({
        files: files,
        code: this.props.serviceCode,
        type: "img-product-category",
      });
      if (checkUpload.code === 1) {
        data.image = checkUpload.data.previewLink;
      }
    } else if (src !== null) {
      data.image = src;
    }
    await this.props.insertProductCategory(data);
    this.loading.stopLoading();
    this.props.history.push("/productMenu/category");
  };
  render() {
    const { t } = this.props;
    return (
      <>
        <Header
          session={t("Product category")}
          title={t("product_category_create_product_category")}
          backIcon={true}
          actionBack={() => this.props.history.push("/productMenu/category")}
        />
        <Grid container spacing={0}>
          <Loading onRef={(id) => (this.loading = id)} />
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Form
              onRef={(id) => (this.form = id)}
              handleAddForm={this.handleAddForm}
            />
          </Grid>
        </Grid>
      </>
    );
  }
}

const mapState = (state) => ({
  serviceCode: state.user.user.roleId.serviceCode,
});

const mapDispatch = (dispatch) => ({
  getProductCategory: dispatch.productCategory.getProductCategory,
  getProduct: dispatch.product.getProduct,
  insertProductCategory: dispatch.productCategory.insertProductCategory,
  uploadDispatch: dispatch.upload,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(style, { withTheme: 0 })(ProductMenu)));
